import { forwardWatchers } from "lib/sagas";

import auth from "domain/core/auth/sagas";
import app from "domain/core/app/sagas";

export default forwardWatchers([auth, app]);
